import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: 'AIzaSyDpPIHXTukdJROfo_teK8dJ87CaxkrNGUA',
    authDomain: 'my-sltp.firebaseapp.com',
    projectId: 'my-sltp',
    storageBucket: 'my-sltp.firebasestorage.app',
    messagingSenderId: '588116264237',
    appId: '1:588116264237:web:c4d2b5b1e0724f19a23fa4',
    measurementId: 'G-6SLDED4MN3',
};

const app = initializeApp(firebaseConfig);
try { getAnalytics(app); } catch (_) {}

export const messaging = getMessaging(app);
export const VAPID_KEY = 'BFu62QJEegTRx_PApNZRq9Y8MuheO37dT4h9o6Fj-9ODnjtC-qlTOwQcb-l7L6rpuF4VZO1tJk3-sMYtYmAorMY';
